<template>
    <div>
        <el-form ref="form" :model="form" :rules="rules" label-width="120px" style="width: 600px;">
            <el-form-item label="语言包文件" prop="jsFileUrl">
                <el-upload accept=".js,.json" class="upload-demo" drag action="" multiple :before-upload="handleBeforeUpload">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">点击或拖拽上传JS或JSON文件
                        <div style="color: #999;margin-top: -20px;font-size: 12px;">支持格式 .js .json</div>
                    </div>
                </el-upload>
                <el-tag v-if="form.jsFileUrl">{{ form.jsFileUrl }}</el-tag>
            </el-form-item>
            <!-- <el-form-item label="关联站点" prop="countryList">
                <el-select v-model="form.countryList" placeholder="请选择站点" multiple>
                    <el-option v-for="item in countries" :key="item.value" :label="item.name"
                        :value="item.value"></el-option>
                </el-select>
            </el-form-item> -->
            <el-form-item label="关联站点" prop="siteIdList">
                <el-select v-model="form.siteIdList" placeholder="请选择站点" multiple>
                    <el-option v-for="item in countries" :key="item.id" :label="item.siteName"
                        :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="语言名称" prop="languageName">
                <el-input v-model="form.languageName" placeholder="请输入语言名称"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button @click="$router.back()">取消</el-button>
                <el-button type="primary" @click="handleSave">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { add, edit, detail, countryList } from "@/api/language";
import { upload } from "@/api/upload";
import { page } from "@/api/site";
export default {
    data() {
        return {
            id: null,
            form: {
                jsFileUrl: "",
                countryList: [],
                siteIdList:[],
                languageName: ""
            },
            countries: [],
            rules: {
                jsFileUrl: [{ required: true, message: '请上传语言包文件' }],
                siteIdList: [{ required: true, message: '请选择关联站点' }],
                languageName: [{ required: true, message: '请输入语言名称' }]
            }
        }
    },
    mounted() {
        this.id = this.$route.query.id;
        if (this.id) {
            this.getDetail();
        }
        this.getCountryList();
    },
    methods: {
        getCountryList() {
            page({
                pageNum: 1,
                pageSize: 100
            }).then(({ code, data, message }) => {
                if (code == 200) {
                    this.countries = data.records;
                } else {
                    this.$message.error(message);
                }
            })  
            // countryList().then(({ code, data, message }) => {
            //     if (code == 200) {
            //         this.countries = data;
            //     } else {
            //         this.$message.error(message);
            //     }
            // })
        },
        getDetail() {
            detail(this.id).then(({ code, data }) => {
                if (code == 200) {
                    this.form = {
                        siteIdList: data.siteIdList,
                        jsFileUrl: data.jsFileUrl,
                        languageName: data.languageName
                    };
                }
            })
        },
        handleBeforeUpload(file) {
            const [, type] = file.type.split("/");
            if (type != "javascript" && type != "json") {
                this.$message.warning("请上传JS文件或JSON文件");
                return;
            }
            upload(file).then(({ code, message, data }) => {
                if (code == 200) {
                    this.form.jsFileUrl = data;
                } else {
                    this.$message.error(message);
                }
            });
            return false;
        },
        handleSave() {
            this.$refs.form.validate(valid => {
                if (!valid) return;
                const params = {
                    ...this.form
                }
                if (!this.id) {
                    add(params).then(({ code, message }) => {
                        if (code == 200) {
                            this.$message.success("添加成功");
                            this.$router.back();
                        } else {
                            this.$message.error(message);
                        }
                    })
                } else {
                    params.id = this.id;
                    edit(params).then(({ code, message }) => {
                        if (code == 200) {
                            this.$message.success("修改成功");
                            this.$router.back();
                        } else {
                            this.$message.error(message);
                        }
                    })
                }
            })
        }
    }
}
</script>

<style></style>